

let autoFocusIdSeq = 0;


export function getNextAutoFocusId() {
	return ++autoFocusIdSeq;
}

export function getCurrentAutoFocusId() {
	return autoFocusIdSeq;
}


